import CriteriaDescription from './CriteriaDescription';

export * from './CriteriaDescription';
export default CriteriaDescription;
